import React from 'react';
import { useParams } from 'react-router-dom';

const AuditLibraries = () => {
  const { version } = useParams(); // 'v1' or 'v2'
  const url = version === 'v1' ? 'https://audit-qv1.cbqaglobal.co.id/' : 'https://audit-q.cbqaglobal.co.id/';

  return (
    <>
      <div className="container-xl" style={{ display: 'flex', flexDirection: 'column', height: '100vh', padding: 0 }}>
        <div className="page-header" style={{ padding: '1rem' }}>
          <div className="page-title">Audit Libraries {version?.toUpperCase()}</div>
        </div>
        <div style={{ flex: 1 }}>
          <iframe 
            src={url} 
            title={`Audit Libraries ${version?.toUpperCase()}`} 
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        </div>
      </div>
    </>
  );
};

export default AuditLibraries;
